module.exports = __webpack_public_path__ + "media/Resources/Podcast-af0bff21.svg";